/**
 * Stable CSS class names for E2E — Order prio drawer.
 */
export const OPD = {
    drawer: 'order-prio-drawer',
    loadingWrap: 'order-prio-drawer__loading-wrap',
    headerRow: 'order-prio-drawer__header-row',
    title: 'order-prio-drawer__title',
    closeButton: 'order-prio-drawer-input--button-close',
    closeIcon: 'order-prio-drawer__close-icon',
    divider: 'order-prio-drawer__divider',
    form: 'order-prio-drawer__form',
    formControlReason: 'order-prio-drawer__form-control-reason',
    formControlType: 'order-prio-drawer__form-control-type',
    selectReason: 'order-prio-drawer-input--select-reason',
    selectType: 'order-prio-drawer-input--select-type',
    dateRangerWrap: 'order-prio-drawer__date-ranger-wrap',
    switchActive: 'order-prio-drawer-input--switch-active',
    submitButton: 'order-prio-drawer-input--button-submit',
} as const;

